<div class="d-inline-block m-2 notification {{className}}" container="body" ngbDropdown>
  <button
    aria-haspopup="true"
    class="btn-dropdown btn-outline notification-bell"
    [class.isUnread]="isUnread()"
    data-toggle="dropdown"
    ngbDropdownToggle
    >
    <i class="bi bi-bell-fill"></i>
  </button>

  <div ngbDropdownMenu class="{{isMobile? 'notification-dropdown-small' :'dropdown-menu-left'}}  notification-dropdown">
    @if (!isLoading()) {
      <div class="notification-box-header">
        <span>{{ '::Notification:label' | abpLocalization }} ({{ unreadNoificationCount() }})</span>
        @if (unreadNoificationCount() !== 0) {
          <button (click)="clearNotification()" class="btn-ouline">
            {{ '::Notification:clearlabel' | abpLocalization }}
          </button>
        }
      </div>
    }

    @if (notificationList().length === 0 && !isLoading()) {
      <div
        class="d-flex text-center h-100 mx-2 justify-content-center align-items-center"
        >
        {{ '::NoNewNotificationsMessage' | abpLocalization }}
      </div>
    }

    @if (notificationList().length > 0 && !isLoading()) {
      <div class="notification-list">
        @for (item of notificationList(); track item) {
          <div class="notification-item">
            <span>
              <i class="{{ item.iconClass }}"></i>
            </span>
            <!--
            The count is passed as {0}. A notification now stands for a whole run of auto-matching
            rather than a single pair, so the key for more than one carries the number; the keys for
            everything else have no placeholder and ignore the extra argument.
            -->
            <p>{{ '::'+item.title | abpLocalization: (item.count?.toString() ?? '') }}</p>
          </div>
        }
      </div>
    }
  </div>
</div>
